import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { PageHeader } from "../../layout/AppLayout";
import { ErpTable } from "../../components/erp";
import { errorText } from "../../api/client";
import { supplierApi, SupplierRow } from "./api";
import { SupplierModal } from "./SupplierModal";

/** Port of v3/Purchase/supplier-list.php */
export default function SupplierList() {
  const list = useQuery({ queryKey: ["purchase", "suppliers"], queryFn: supplierApi.list });
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState<SupplierRow | null>(null);
  const rows = list.data?.Data || [];
  return (
    <>
      <PageHeader title="Suppliers List" location="Purchase" />
      <div className="row"><div className="col-12"><div className="card"><div className="card-body">
        <div className="text-center mb-3"><button type="button" className="btn btn-success waves-effect waves-light" onClick={() => { setEdit(null); setOpen(true); }} data-testid="btn-new-supplier"><i className="fa fa-plus" /> New Supplier</button></div>
        <ErpTable<SupplierRow> rows={rows} loading={list.isLoading} error={list.isError ? errorText(list.error) : list.data?.Error || null} testId="supplier-list-table"
          columns={[
            { key: "SNO", title: "S.No" }, { key: "SupplierName", title: "Supplier Name" }, { key: "PanNumber", title: "PAN No" }, { key: "BankName", title: "Bank Name" },
            { key: "BankAccNo", title: "Account No" }, { key: "IFSC", title: "IFSC" }, { key: "GstNo", title: "GST No" },
            { key: "act", title: "Actions", render: (r) => <button type="button" className="btn btn-link p-0 text-primary" onClick={() => { setEdit(r); setOpen(true); }} data-testid={`edit-supplier-${r.SupplierID}`}><i className="mdi mdi-pencil font-size-18" /></button> },
          ]} />
      </div></div></div></div>
      {open && <SupplierModal open={open} onClose={() => setOpen(false)} onSaved={() => setOpen(false)}
        initial={edit ? { SupplierID: String(edit.SupplierID), SupplierType: edit.SupplierType || "", SupplierName: edit.SupplierName || "", GSTNumber: edit.GstNo || "", PANNumber: edit.PanNumber || "",
          SupplierBank: edit.BankName || "", BankAccNo: edit.BankAccNo || "", IFSCCode: edit.IFSC || "", Address: edit.Address || "", EMailID: edit.EMailID || "", PhoneNumber: edit.PhoneNumber || "", PurchaseCenter: edit.PurchaseCenter || "" } : undefined} />}
    </>
  );
}
